import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {fetchCompany} from '../../../company/actions';
import {updatePersonalTrustpass} from '../../personalTrustpassActions';

import Layout from '../../../shared/components/layouts/MainLayout';
import PersonalTrustpassInformationForm from '../../components/personal/InformationForm';

import {segmentEventTracker} from '../../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../../shared/constants/SegmentEvents';

export class PersonalTrustpassInformationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      personal_trustpass: this.setPersonalTrustPassDefaultState(),
      errors: {},
    };

    this.onFocus = this.onFocus.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(fetchCompany());
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(
      PageViewName.ONBOARDING_PERSONAL_INFO_VIEWED,
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.personal_trustpass.id && this.props.personal_trustpass.id) {
      this.setState({
        personal_trustpass: this.setPersonalTrustPassDefaultState(),
      });
    }
  }

  setPersonalTrustPassDefaultState = () => {
    if (this.props.personal_trustpass.first_name != null)
      return this.props.personal_trustpass;

    return {
      first_name: this.props.company.first_name || this.props.user.first_name,
      last_name: this.props.company.last_name || this.props.user.last_name,
      phone_number: this.props.company.phone || this.props.user.phones[0],
      email_address: this.props.company.email || this.props.user.email,
    };
  };

  onBack = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
    this.props.dispatch(push('/requirements'));
  };

  submit() {
    const onSuccess = () => {
      this.setState({errors: {}, submitting: false}, () => {
        this.props.dispatch(push('/requirements'));
      });
    };
    const onError = errors => {
      this.setState({submitting: false, errors});
    };

    this.props.dispatch(
      updatePersonalTrustpass(
        {
          userId: this.props.user_id,
          personalTrustpassId: this.props.personal_trustpass.id,
        },
        this.state.personal_trustpass,
        onSuccess,
        onError,
      ),
    );
  }

  onSave() {
    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FORM_CLICKED);
    this.setState({submitting: true});
    this.submit();
  }

  onChangeValue(field) {
    return e => {
      const value = e.target.value;
      const new_personal_trustpass = Object.assign(
        {},
        this.state.personal_trustpass,
        {[field]: value},
      );
      this.setState({personal_trustpass: new_personal_trustpass});
    };
  }

  onFocus(e) {
    const name = e.target.name;
    switch (name) {
      case 'civil_status':
        segmentEventTracker.trackEvent(TrackEventName.CIVIL_STATUS_FOCUSED);
        break;
      case 'gender':
        segmentEventTracker.trackEvent(TrackEventName.GENDER_FOCUSED);
        break;
      case 'year':
        segmentEventTracker.trackEvent(TrackEventName.BIRTH_YEAR_FOCUSED);
        break;
      case 'month':
        segmentEventTracker.trackEvent(TrackEventName.BIRTH_MONTH_FOCUSED);
        break;
      case 'day':
        segmentEventTracker.trackEvent(TrackEventName.BIRTH_DAY_FOCUSED);
        break;
      default:
        return null;
    }
  }

  isSaveDisabled() {
    const status = this.props.personal_trustpass.information_status;
    return status === 'rejected' || status === 'verified';
  }

  render() {
    return (
      <Layout
        header="Complete Your Personal Information"
        backButtonAction={this.onBack}>
        <div className="ds-card _tight">
          <section className="cardSection">
            <h2 className="subhead">Personal Information</h2>
            <p className="byline">
              Please ensure the details below relate to an
              <b className="emphasize"> owner or director</b> of the business
              you are applying for.
            </p>
          </section>

          <section className="cardSection _withColumns _formError _simple -bgWarning">
            {' '}
            <i className="materialIcon _outlined --micro -warning _withBorder">
              assignment
            </i>
            <div className="text _widthAuto">
              <p className="label emphasize -warning">Please complete</p>
              <ul className="listText --micro">
                <li>Birth Date</li>
                <li>Gender</li>
                <li>Civil Status</li>
                <li>Home Address</li>
              </ul>
            </div>
          </section>

          <PersonalTrustpassInformationForm
            company={{...this.props.company}}
            information={this.state.personal_trustpass}
            submitting={this.state.submitting}
            errors={this.state.errors}
            disabled={this.isSaveDisabled()}
            onSave={this.onSave}
            onFocus={this.onFocus}
            onChangeValue={this.onChangeValue}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    user_id: state.user.id,
    company: state.company,
    personal_trustpass: state.personal_trustpass,
  };
};

export default connect(mapStateToProps)(PersonalTrustpassInformationContainer);



// WEBPACK FOOTER //
// ./src/features/trustpass/containers/personal/InformationContainer.js